var _rect, _circle, _path, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 26,
    height: 26,
    rx: 7.72414,
    fill: "#E8DEF1",
    stroke: "#510C76"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.0003,
    cy: 15.552,
    r: 3.58621,
    fill: "white",
    stroke: "#510C76"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2822 14.3301L16.7184 16.7746",
    stroke: "#510C76",
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.0001,
    cy: 21.8282,
    r: 0.5,
    fill: "#E8DEF1",
    stroke: "#510C76",
    strokeWidth: 0.793103
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAp);
export default __webpack_public_path__ + "static/media/ap.88abe7c573a9d72d45a40b9229819d5c.svg";
export { ForwardRef as ReactComponent };